import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=f247b5d4&scoped=true&"
import script from "./applyList.vue?vue&type=script&lang=js&"
export * from "./applyList.vue?vue&type=script&lang=js&"
import style0 from "./applyList.vue?vue&type=style&index=0&id=f247b5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f247b5d4",
  null
  
)

export default component.exports